import { Tax } from '../Taxes/Model';
import { ReceiptLayout } from '../ReceiptLayouts/Model';
import PassengerCategory from '../PassengerCategories/Model';
import Headboard from '../Headboards/Headboard';
import { MapSite, SeatZone } from '../SeatingAreas/Model';
var Stretch = /** @class */ (function () {
    function Stretch(props) {
        this.prices = [];
        this.disabledDays = [];
        this.vueltaPrices = [];
        if (!props)
            return;
        Object.assign(this, props);
        /*this.hora = {hours: props.hours, minutes: props.minutes}*/
        if (props.prices) {
            this.prices = props.prices.map(function (value) { return new StretchPrice(value); });
        }
        if (props.receiptLayout)
            this.receiptLayout = new ReceiptLayout(props.receiptLayout);
        if (props.tax)
            this.tax = new Tax(props.tax);
        if (!props.horasIda)
            this.horasIda = [];
        if (!props.horasVuelta)
            this.horasVuelta = [];
        if (props.headboard)
            this.headboard = new Headboard(props.headboard);
        this.mapSite = new MapSite();
        if (props.mapSite && props.mapSite.seatZones) {
            this.mapSite.seatZones = props.mapSite.seatZones.map(function (seatZone) { return new SeatZone(seatZone); });
        }
        else {
            this.mapSite.seatZones = [];
        }
        if (props.stretchOtas) {
            this.stretchOtas = props.stretchOtas.map(function (value) { return new StretchOta(value); });
        }
        if (props.dateMaxToReserve) {
            this.dateMaxToReserve = new Date(props.dateMaxToReserve);
        }
        // console.log('Stretch - constructor - props: ', this)
    }
    return Stretch;
}());
export default Stretch;
var StretchOta = /** @class */ (function () {
    function StretchOta(props) {
        Object.assign(this, props);
    }
    return StretchOta;
}());
export { StretchOta };
var StretchPrice = /** @class */ (function () {
    function StretchPrice(values) {
        Object.assign(this, values);
        // console.log('Stretch - constructor - values: ', values)
        this.price = values.price;
        // let temp: any = values
        // delete temp.price
        // console.log('Stretch - constructor - temp: ', temp)
        // this.passengerCategory = new PassengerCategory(temp)
        this.printPrice = values.printPrice;
        if (values.passengerCategory) {
            this.passengerCategory = new PassengerCategory(values.passengerCategory);
        }
        if (values.datePrices) {
            this.datePrices = values.datePrices.map(function (value) { return new StretchPriceDate(value); });
        }
    }
    return StretchPrice;
}());
export { StretchPrice };
var StretchPriceDate = /** @class */ (function () {
    function StretchPriceDate(props) {
        Object.assign(this, props);
    }
    return StretchPriceDate;
}());
export { StretchPriceDate };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/Model.ts
// module id = 94
// module chunks = 0